export { default } from "./DetailsLink";
export { default as detailsReducer } from "./slice";
export { useDetails } from "./hooks";
